import { useState } from 'react';
import {
  Box,
  Typography,
  Container,
  Button,
  Grid
} from 'src/components';
import { Helmet } from 'react-helmet-async';

import Accordion from 'src/components/Accordion';
import AccordionSummary from 'src/components/AccordionSummary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionDetails from 'src/components/AccordionDetails';
import { useNavigate } from 'react-router';
import HomeIcon from '@mui/icons-material/Home';

interface IStatus500Props {
  error: string;
  errorDetail: string;
}
const Status500 = (props: IStatus500Props) => {
  const [pending, setPending] = useState(false);
  function handleClick() {
    setPending(true);
  }
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>Status - 500</title>
      </Helmet>

      <Container maxWidth="md">
        <Box textAlign="center">
          <img
            alt="500"
            height={260}
            src="/static/images/status/500.svg"
          />
          <Typography variant="h4" sx={{ my: 2 }}>
            {props.error}
            {/* There was an error, please try again later */}
          </Typography>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography textAlign={"right"}>Detail</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography textAlign="left">
                {props.errorDetail}
              </Typography>
            </AccordionDetails>
          </Accordion>
          {/* The server encountered an internal error and was not able to
                  complete your request */}
          <Grid container justifyContent={"center"} sx={{ paddingTop: 5 }}>
            <Grid item md={12}>
              <Button fullWidth={false} href="/" variant="contained" sx={{ ml: 1 }}>
                <HomeIcon>
                </HomeIcon>
                Ana Sayfaya Dön
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  );
}

export default Status500;
